import React, { useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc
} from "firebase/firestore";
import { db, auth } from "../firebase";
import { logAudit } from "../auditLogger";

const SupervisorOverride = () => {
  const [date, setDate] = useState("");
  const [sku, setSku] = useState("");
  const [rows, setRows] = useState([]);
  const [reason, setReason] = useState("");

  // Load closed stock record
  const loadRecord = async () => {
    if (!date || !sku) {
      alert("Date and SKU are required");
      return;
    }

    const q = query(
      collection(db, "daily_stock"),
      where("date", "==", date),
      where("sku", "==", sku),
      where("dayClosed", "==", true)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      alert("No closed stock found for this Date + SKU");
      setRows([]);
      return;
    }

    setRows(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  // Override physical stock
  const overrideStock = async (row, newPhysical) => {
    if (newPhysical === "" || newPhysical === null) {
      alert("Physical stock is required");
      return;
    }

    if (newPhysical < 0) {
      alert("Negative stock not allowed");
      return;
    }

    if (!reason.trim()) {
      alert("Override reason is mandatory");
      return;
    }

    const newDiff = Number(newPhysical) - row.systemStock;

    // Update daily stock
    await updateDoc(doc(db, "daily_stock", row.id), {
      physicalStock: Number(newPhysical),
      difference: newDiff,
      remarks: reason
    });

    // Audit log
    await logAudit({
      module: "WAREHOUSE",
      action: "OVERRIDE",
      refCollection: "daily_stock",
      refDocId: row.id,
      sku: row.sku,
      date: row.date,
      oldData: {
        physicalStock: row.physicalStock,
        difference: row.difference,
        remarks: row.remarks
      },
      newData: {
        physicalStock: Number(newPhysical),
        difference: newDiff,
        remarks: reason
      },
      role: "SUPERVISOR"
    });

    alert("Override completed successfully");

    // Reload record
    loadRecord();
  };

  return (
    <div>
      <h2>Supervisor Stock Override</h2>

      <div style={{ marginBottom: "10px" }}>
        <input
          type="date"
          value={date}
          onChange={e => setDate(e.target.value)}
        />
        <input
          placeholder="SKU"
          value={sku}
          onChange={e => setSku(e.target.value)}
        />
        <button onClick={loadRecord}>Load</button>
      </div>

      {rows.map(row => (
        <div
          key={row.id}
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            marginBottom: "10px"
          }}
        >
          <b>SKU:</b> {row.sku}<br />
          <b>System Stock:</b> {row.systemStock}<br />
          <b>Current Physical:</b> {row.physicalStock}<br />
          <b>Difference:</b> {row.difference}<br />

          <br />
          <label>New Physical Stock:</label><br />
          <input
            type="number"
            onBlur={e => overrideStock(row, e.target.value)}
          />

          <br /><br />
          <label>Override Reason:</label><br />
          <input
            type="text"
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </div>
      ))}
    </div>
  );
};

export default SupervisorOverride;
